





















import { Component, Prop } from 'vue-property-decorator';
import {
    DxTreeList,
    DxColumn,
    DxEditing,
    DxScrolling,
    DxForm,
    DxRemoteOperations
} from 'devextreme-vue/tree-list';
import { DxItem } from 'devextreme-vue/form';
import DataSource from 'devextreme/data/data_source';
import {
    Tree,
    TreeConfig,
    defaultTreeConfig
} from '@/core/components/tree';
import {
    CONTRACTS,
    WindowsServiceContract,
    FetchServiceContract
} from '@/core/contracts';
import { Inject } from '@/core/helpers/vue-inversify-decorator';
import { ResourceTypeRelation, ResourceTypeTree } from '@/dto';
import { ContextsState } from '@/store';
import { localize } from '@/core/filters';
import DevExpress from 'devextreme/bundles/dx.all';
import { DxRequiredRule, DxCustomRule } from 'devextreme-vue/validator';
import Validators from '@/core/helpers/validators';
import ResourceTypesDependences from './types';
import { prepareFilters } from '@/core/components/tree/treeHelpers';

@Component({
    components: {
        DxTreeList,
        DxColumn,
        DxEditing,
        DxForm,
        DxItem,
        DxRequiredRule,
        DxRemoteOperations,
        DxScrolling,
        DxCustomRule
    }
})
export default class ResourceTypesListTable extends Validators {
    @Prop({ type: String, required: true }) public treeKey!: string;

    private reloading: boolean = false;

    @Inject(CONTRACTS.WindowsService)
    private _windowsService?: WindowsServiceContract;
    @Inject(CONTRACTS.FetchService)
    private _fetchService?: FetchServiceContract;

    public get treeConfig(): Partial<TreeConfig> {
        return {
            ...defaultTreeConfig(this)
        };
    }

    public get dataSource(): DataSource {
        return new DataSource({
            key: 'treeId' as keyof ResourceTypeTree,
            load: this.load
        });
    }

    public updateTableInstance() {
        this.reloading = true;
        this.treeInstance.getDataSource().reload();
    }

    public currentItem() {
        let item = null;
        if (this.treeInstance) {
            item = this.treeInstance!.getSelectedRowsData()[0];
        }
        return item ? item : null;
    }

    public async mounted() {
        // raise instance of the tree up to parent
        this.$emit('setTreeInstance', this.treeInstance);
    }

    public get treeInstance(): Tree {
        const element = this.$refs['tree-list'] as unknown;
        return (element as DxTreeList).instance!;
    }

    public get localize() {
        return localize;
    }

    public deleteResourceType() {
        this._windowsService!.showDialog(
            localize('ResourceTypeSimpleDeleteMessage'),
            [
                { id: 1, caption: localize('DialogYes') },
                { id: 2, caption: localize('DialogCancel') }
            ]
        )
        .then(id => {
            if (id === 1) {
                this.deleteProcess();
            }
        });
    }

    private async getDependences(resourceTypeId: string) {
        const currentContextId = ContextsState.currentContextId;
        const relationsURL = `/contexts/${currentContextId}/resourceTypesList/dependences/${resourceTypeId}`;
        return await this._fetchService!.get<ResourceTypesDependences>(relationsURL);
    }

    private onEdit() {
        this.$emit('onEdit');
    }

    private async load(loadOptions: any) {
        const currentContextId = ContextsState.currentContextId;
        let parameters = '';
        let url = '';

        if (loadOptions.parentIds) {
            if (this.reloading) {
                url = `/contexts/${currentContextId}/resourceTypesList/`;
                this.reloading = false;
            } else {
                const selectedId = loadOptions.parentIds[loadOptions.parentIds.length - 1];
                url = `/contexts/${currentContextId}/resourceTypesList/${selectedId}`;
            }
        } else {
            parameters = loadOptions.filter ? prepareFilters(loadOptions.filter) : '';
            url = `/contexts/${currentContextId}/resourceTypesList/filter/${parameters}`;
        }

        const data = await this._fetchService!.get<ResourceTypeTree[]>(url);
        return data ? data : [];
    }

    private async deleteProcess() {
        const currentContextId = ContextsState.currentContextId;
        const resourceTypeId = this.treeInstance.getSelectedRowsData()[0].alias;
        const dependences: ResourceTypesDependences = await this.getDependences(resourceTypeId);
        if (!this.checkDependencesExist(dependences)) {
            const data = {
                            ResourceTypes_Partial: [
                                {
                                    id: resourceTypeId,
                                    IsDeleted: true
                                }
                            ]
                        };

            const url = `/files/contexts/${currentContextId}?ignoreWarnings=true`;
            this._fetchService!.post<ResourceTypeTree>(
                url,
                JSON.stringify(data)
            );
        } else {
            this.$emit('showDependences', dependences);
        }
    }

    private checkDependencesExist(relations: ResourceTypesDependences): boolean {
        let count: number = 0;

        count += relations.childResourceTypes.length;
        count += relations.channels.length;
        count += relations.cranes.length;
        count += relations.vehicles.length;
        count += relations.products.length;
        count += relations.replacements.length;
        count += relations.sites.length;
        count += relations.unknownResources.length;

        return count > 0;
    }
}
